import { CANTRATE_ID } from '@webapp/common/resources/constants';

import { calcAndSetAnsweredCount } from '@webapp/survey/src/api/types/common/utils';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class SelectFewImageApi extends QuestionSimpleApi {
    public change(q: QuestionContext, evt: ResponseEventParams): void {
        const { value, questionId, answerId } = evt;
        const { answersActors, responseActor } = q;
        responseActor.send({ type: 'CHANGE', value, questionId });

        if (value === CANTRATE_ID) {
            answersActors.forEach((answersActor) => {
                const otherAnswer = answersActor.getSnapshot().context;
                otherAnswer.response?.send({ type: 'SET', value: false });
            });
        } else {
            answersActors.forEach((answersActor) => {
                const otherAnswer = answersActor.getSnapshot().context;
                const answerRaw = answersActors.find((a) => {
                    return a.getSnapshot().context.id === answerId;
                });
                const answer = answerRaw.getSnapshot().context;

                if ((answer.exception || otherAnswer.exception) && answer.id !== otherAnswer.id) {
                    otherAnswer.response.send({ type: 'SET', value: false });
                }
            });

            calcAndSetAnsweredCount(q);
        }
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { id, answersActors, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        let data;

        if (value === CANTRATE_ID) {
            data = [{ cantRate: true, bool: true }];
        } else {
            data = answersActors.map((answersActor) => {
                const { id, response: responseActor } = answersActor.getSnapshot().context;
                const response = responseActor.getSnapshot().context;
                return { answer: id, bool: (response.value as boolean) || false };
            });
        }

        return {
            question: id,
            data,
            comment,
        };
    }

    public validate(q: QuestionContext): boolean {
        const {
            answersActors,
            params: { maxLength, minLength, required },
            responseActor,
        } = q;
        const response = responseActor.getSnapshot().context;
        const answersCount = answersActors.reduce((acc, actor) => {
            const { response } = actor.getSnapshot().context;
            return acc + Number(response.getSnapshot().context.value);
        }, 0);

        if (!required || Number(response.value) === CANTRATE_ID) return true;

        // FIXME
        q.answeredCount = answersCount;

        const withMinLen = minLength !== null;
        const withMaxLen = maxLength !== null;

        if ((withMinLen && answersCount < minLength) || (withMaxLen && maxLength < answersCount)) {
            // FIXME
            q.invalid = true;
            return false;
        }

        return answersCount > 0;
    }
}
